export default __webpack_public_path__ + "images/64558a72b2db27c1091f33ba4510c02a.svg";